import { API_BASE_URL } from '../config/api';

export const getAuthToken = (): string | null => {
  const session = localStorage.getItem('googleSession');
  if (!session) return null;

  try {
    const { idToken, expiresAt } = JSON.parse(session);
    if (Date.now() >= expiresAt) {
      removeAuthToken();
      return null;
    }
    return idToken;
  } catch (error) {
    console.error('Error parsing auth token:', error);
    return null;
  }
};

export const setAuthToken = (token: string, expiresAt: number): void => {
  const session = {
    idToken: token,
    expiresAt: expiresAt
  };
  localStorage.setItem('googleSession', JSON.stringify(session));
};

export const removeAuthToken = (): void => {
  localStorage.removeItem('googleSession');
};

export const isAuthenticated = (): boolean => {
  return !!getAuthToken();
};

export const getAuthHeaders = (): HeadersInit => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}; 